import React, { useState } from "react";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";

import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";
import Button from "../../atoms/button/button";
import CardLaboratory from "../../atoms/cardLaboratory/cardLaboratory";

import "./gridSectionLab.scss";

const GridSectionLab = (props: ReferenciaContenido) => {
  const [elementShow, setElementShow] = useState(9);
  const [elementShowMobile, setElementShowMobile] = useState(5);
  const [elementShowMIpad, setElementShowIpad] = useState(4);
  const arr = Array();

  for (let i = 0; i < props.referenciaPlantillaContenido.length; i++) {
    arr.push(props.referenciaPlantillaContenido[i]);
  }

  const showHandler = () => {
    setElementShow(elementShow >= arr.length ? elementShow : elementShow + 3);
  };

  //Mobile
  const showHandlerMobile = () => {
    setElementShowMobile(
      elementShowMobile >= arr.length
        ? elementShowMobile
        : elementShowMobile + 5
    );
  };

  //iPad
  const showHandlerIpad = () => {
    setElementShowIpad(
      elementShowMIpad >= arr.length ? elementShowMIpad : elementShowMIpad + 4
    );
  };

  return (
    <div className="o-gridsection-lab-container">
      <div className="desktop-lab hide-on-mobile">
        <div className="o-gridsection-lab-title">{props.tituloGeneral}</div>
        <div className="o-gridsection-lab-subtitle">
          {documentToReactComponents(props.descripcion.json)}
        </div>
        <div className="o-gridsection-lab-grid">
          {arr.slice(0, elementShow).map((elem, i) => {
            return (
              <div className="o-gridsection-lab-grid--innerelements" key={i}>
                <CardLaboratory
                  titleDescription={elem.tituloDescripcion}
                  titleBanner={elem.tituloBanner}
                  typeTitle={elem.tipoTitulo}
                  description={elem.descripcion.json}
                  bottonRedirect={elem.redireccionBoton}
                  imgUrl={elem.imagenPrincipal[0]}
                  key={i}
                />
              </div>
            );
          })}
        </div>
        <div
          className="o-gridsection-lab-vermas"
          style={{
            display: elementShow >= arr.length ? "none" : "flex",
          }}
        >
          <Button
            type="button"
            classname=""
            text="VER MÁS"
            isDisabled={false}
            onClickAction={showHandler}
          />
        </div>
      </div>

      <div className="ipad-lab">
        <div className="o-gridsection-lab-title">{props.tituloGeneral}</div>
        <div className="o-gridsection-lab-subtitle">
          {documentToReactComponents(props.descripcion.json)}
        </div>
        <div className="o-gridsection-lab-grid">
          {arr.slice(0, elementShowMIpad).map((elem, i) => {
            return (
              <div
                className="o-gridsection-lab-grid--innerelementsmobile"
                key={i}
              >
                <CardLaboratory
                  titleDescription={elem.tituloDescripcion}
                  titleBanner={elem.tituloBanner}
                  typeTitle={elem.tipoTitulo}
                  description={elem.descripcion.json}
                  bottonRedirect={elem.redireccionBoton}
                  imgUrl={elem.imagenPrincipal[0]}
                  key={i}
                />
              </div>
            );
          })}
        </div>
        <div
          className="o-gridsection-club-vermas"
          style={{
            display: elementShowMobile >= arr.length ? "none" : "flex",
          }}
        >
          <Button
            type="button"
            classname=""
            text="VER MÁS"
            isDisabled={false}
            onClickAction={() => {
              showHandlerIpad();
            }}
          />
        </div>
      </div>

      <div className="mobile-lab">
        <div className="o-gridsection-lab-title">{props.tituloGeneral}</div>
        <div className="o-gridsection-lab-subtitle">
          {documentToReactComponents(props.descripcion.json)}
        </div>
        <div className="o-gridsection-lab-grid">
          {arr.slice(0, elementShowMobile).map((elem, i) => {
            return (
              <div
                key={i}
                className="o-gridsection-lab-grid--innerelementsmobile"
              >
                <CardLaboratory
                  titleDescription={elem.tituloDescripcion}
                  titleBanner={elem.tituloBanner}
                  typeTitle={elem.tipoTitulo}
                  description={elem.descripcion.json}
                  bottonRedirect={elem.redireccionBoton}
                  imgUrl={elem.imagenPrincipal[0]}
                  key={i}
                />
              </div>
            );
          })}
        </div>
        <div
          className="o-gridsection-lab-vermas"
          style={{
            display: elementShowMobile >= arr.length ? "none" : "flex",
          }}
        >
          <Button
            type="button"
            classname=""
            text="VER MÁS"
            isDisabled={false}
            onClickAction={() => {
              showHandlerMobile();
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default GridSectionLab;
